import React from 'react';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import { makeStyles, } from '@mui/styles';
import { StyledTextField, } from '../../Reusable';

const useStyles = makeStyles({
  root: {
    paddingLeft: '10px',
    paddingRight: '5px',
  },
  title: {
    flex: '1 1 45%',
  },
});

const AlertsTableToolbar = ({
  handleSearch,
}: {
  // eslint-disable-next-line no-unused-vars
  handleSearch: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void
}) => {
  const classes = useStyles();
  return (
    <div>
      <Toolbar>
        <Typography
          className={classes.title}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Connections
        </Typography>
        <Tooltip title="Search by name">
          <StyledTextField
            className="align-items-end"
            style={{ paddingRight: '10px', }}
            size={'small'}
            name="search"
            label="Search"
            color="primary"
            onChange={(event) => {
              handleSearch(event);
            }}
          />
        </Tooltip>
      </Toolbar>
    </div>
  );
};

export default AlertsTableToolbar;
